import {Module} from 'vuex'
import {RootState} from '@/store/store-types'
import {useUserApi} from '@/core/api/users'
import {User, UserPayload} from '@/core/models/user'

const state: User = new User(<UserPayload>{})

export const user: Module<User, RootState> = {
    namespaced: true,
    state,
    mutations: {
        update: (state: User, payload: UserPayload) => {
            state.fill(payload)
        },
    },
    actions: {
        get: <T>(context: any, payload: { id: number }): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useUserApi()
                    .find(payload.id)
                    .then((data: any) => {
                        context.commit('update', data.data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
        update: <T>(context: any, payload: { id: number, payload: UserPayload }): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useUserApi()
                    .update(payload.id, payload.payload)
                    .then((data: any) => {
                        context.commit('update', data.data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        },
    },
    getters: {
        get: (state: User): User => {
            return state
        }
    }
}
